import React, { Component } from "react";
import dayjs from "dayjs";
import { MessageType } from "./Message";
import file from "../../../images/file.png";
import Retry from "./RetryMessage";

class DocumentMessage extends Component {
  showMessageTime = () => {
    return this.props.message.type !== MessageType.info;
  };

  messageTimeClassName = () => {
    switch (this.props.message.type) {
      case MessageType.sent:
        return "s360-message-time-sent";
      case MessageType.received:
        return "s360-message-time-received";
      default:
        return "";
    }
  };

  messageBoxClassName = () => {
    switch (this.props.message.type) {
      case MessageType.sent:
        return "s360-message-box-sent";
      case MessageType.received:
        return "s360-message-box-received";
      default:
        return "";
    }
  };

  messageContainerClassName = () => {
    switch (this.props.message.type) {
      case MessageType.sent:
        return "s360-message-cotainer-sent";
      case MessageType.received:
        return "s360-message-cotainer-received";
      default:
        return "";
    }
  };

  messageBoxStyle = () => {
    let config = this.props.config;
    switch (this.props.message.type) {
      case MessageType.sent:
        return {
          height: "105px",
          background: "#FFFFFF",
          fontFamily: config.designDetails.ReceiverMessageFont,
          fontSize: config.designDetails.ReceiverMessageFontSize,
          color: config.designDetails.recieverMessageFontColor,
        };
      case MessageType.received:
        return {
          height: "105px",
          background: "#FFFFFF",
          fontFamily: config.designDetails.SenderMessageFont,
          fontSize: config.designDetails.SenderMessageFontSize,
          color: config.designDetails.senderMessageFontColor,
        };
      default:
        return {};
    }
  };

  messageContainerStyle = () => {
    // let config = this.props.config
    return {};
  };

  messageTimeStyle = () => {
    let config = this.props.config;
    // let fontSize = config.designDetails.messageFontSize - (config.designDetails.messageFontSize / 4);
    switch (this.props.message.type) {
      case MessageType.received:
        return {
          fontFamily: config.designDetails.messageFont,
          fontSize: config.designDetails.messageTimeFontSize,
          color: config.designDetails.messageTimeFontColor,
        };
      case MessageType.sent:
        return {
          fontFamily: config.designDetails.messageFont,
          fontSize: config.designDetails.messageTimeFontSize,
          color: config.designDetails.messageTimeFontColor,
        };
      case MessageType.info:
        return {
          fontFamily: config.designDetails.messageFont,
          fontSize: config.designDetails.messageTimeFontSize,
          color: config.designDetails.messageTimeFontColor,
        };
      default:
        return {};
    }
  };

  documentSVGImage = (imageColor, width, height) => {
    // return <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
    //     // width={width || "100%"} height={height || "100%"}
    //     viewBox="0 0 172 172"
    //     style={{ fill: imageColor }}><g fill="none" fillRule="nonzero" stroke="none" strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeDasharray="" strokeDashoffset="0" fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none" style={{ mixBlendMode: "normal" }}><path d="M0,172v-172h172v172z" fill="none"></path><g id="original-icon" fill={imageColor}><path d="M10.07813,10.16211l20.24024,65.08789h130.93164zM30.31836,86l-20.24024,65.0459l151.17188,-65.0459z"></path></g></g></svg>

    return (
      <svg
        focusable="false"
        aria-hidden="true"
        x="0px"
        y="0px"
        viewBox="0 0 15 16"
        width="15px"
        height="16px"
        style={{ fill: imageColor }}
      ></svg>
    );
  };

  render() {
    return (
      <div
        className={this.messageContainerClassName()}
        style={this.messageContainerStyle()}
      >
        <div
          className={this.messageBoxClassName()}
          style={this.messageBoxStyle()}
        >
          <a
            target="_blank"
            href={this.props.message.message.text}
            download
            rel="noreferrer"
          >
            <img
              width="100"
              height="100"
              title={this.props.message.message.text}
              src={file}
              alt="text"
            ></img>
          </a>
        </div>
        <div style={{ display: "flex", alignItems: "center", marginRight: 7 }}>
          {this.showMessageTime() && (
            <div
              className={this.messageTimeClassName()}
              style={this.messageTimeStyle()}
            >
              {dayjs
                .unix(
                  Math.trunc(this.props.message.message.sentTimestamp / 1000)
                )
                .format("DD MMM h:mm a")}
            </div>
          )}
          <Retry {...this.props} />
        </div>
      </div>
    );
  }
}

export default DocumentMessage;
